export default "__VITE_ASSET__DS2HS0tp__"